/* eslint-disable import/no-cycle */
import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'budget_logs';

export default {
  async getByBudgetId(budgetId) {
    const url = mountUrl(`/${BASE_PATH}/budget/${budgetId}`);
    return api.get(url);
  },
  async search(queryParams) {
    const url = mountUrl(`/${BASE_PATH}`, queryParams);
    return api.get(url);
  },
  async create(body) {
    const url = mountUrl(`/${BASE_PATH}`);
    return api.post(url, body);
  }
};
